<canvas #canvas style="width: 100%; height: 300px"></canvas>

<!-- {{ closestDataPoint | json }} -->

<div
  #tooltip
  class="tooltip"
  [class.active]="closestDataPoint">

  <ng-container *ngIf="closestDataPoint as d">
    <div class="tooltip-head">
      <div class="date">{{ d.id | date }}</div>
      <div class="owners" *ngIf="environment.collection !== 'cryptopunks-v1'">
        <span>Holders</span> {{ d.owners | number }}
      </div>
    </div>

    <div class="floor-vol">
      <!--
      <div class="floor">
        <div class="label">Floor</div>
        <div class="value">
          Ξ {{ d.floor | weiToEth | number : '1.0-2' }}
        </div>
      </div>
        -->

      <div class="volume">
        <div class="label">Volume</div>
        <div class="value">Ξ {{ d.volume | weiToEth | formatCash }}</div>
      </div>
    </div>

    <div class="sales-wrapper">

      <div
        *ngIf="d.topSale?.value"
        class="top-sale">

        <img
          [lazyLoad]="dataSvc.staticUrl + dataSvc.tokenImagePath + (d.topSale.tokenId | tokenIdParse) + '.svg'"
          [defaultImage]="environment.collection === 'cryptophunks' ? 'assets/loadingphunk.png' : 'assets/loadingpunk.png'"          
          width="48"
          height="48"
        />

        <div class="lv">
          <div class="label-wrapper">
            <span class="label">Top Sale</span>
            <span class="numb">{{ d.sales }} Sales</span>
          </div>
          <div class="punkid">{{ environment.tokenName }} #{{ d.topSale.tokenId }}</div>
          <div class="value">Ξ {{ d.topSale.value | weiToEth | number : '1.0-2' }}</div>
        </div>
      </div>
    </div>

    <div class="bids-wrapper">
        
      <div
        *ngIf="d.topBid?.value"
        class="top-bid">

        <img
          [lazyLoad]="dataSvc.staticUrl + dataSvc.tokenImagePath + (d.topBid.tokenId | tokenIdParse) + '.svg'"
          [defaultImage]="environment.collection === 'cryptophunks' ? 'assets/loadingphunk.png' : 'assets/loadingpunk.png'"          
          width="48"
          height="48"
        />

        <div class="lv">
          <div class="label-wrapper">
            <span class="label">Top Bid</span>
            <span class="numb">{{ d.bids }} Bids</span>
          </div>
          <div class="punkid">{{ environment.tokenName }} #{{ d.topBid.tokenId }}</div>
          <div class="value">Ξ {{ d.topBid.value | weiToEth | number : '1.0-2' }}</div>
        </div>
      </div>
    </div>

  </ng-container>
</div>